import {
  FETCH_WAREHOUSE_VISIBLE_RETAILERS_LIST,
  RESET_WAREHOUSE_VISIBLE_RETAILERS_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const warehouseVisibilityRetailersListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_WAREHOUSE_VISIBLE_RETAILERS_LIST:
      return { list: action.payload, others: action.others };
    case RESET_WAREHOUSE_VISIBLE_RETAILERS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default warehouseVisibilityRetailersListReducer;
